import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

// Necesarios para utilizar Observable
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { Observable } from 'rxjs/Observable';

// Interface con los datos que devuelve el API
import { HttpClient, HttpParams } from '@angular/common/http';
import { IReceiverCriteria } from "../model/receiver-criteria";
import { IReceiverList } from "../model/receiver-list";
import { IPerson } from '../model/person';
import { IReceiver } from '../model/receiver';
import { IReceiverFilter } from '../model/receiver-filter';
import { IPlatform } from '../model/platform';
import { SpinnerService } from './spinner.service';

/**
 * Servicio de gestion de receivers
 */
@Injectable()
export class ReceiverService {
  private receiversUrl = environment.apiUrl + '/v1/receivers';
  private invoicingServiceUrl = environment.apiUrl + '/v1/invoicing-services/';
  private clientsServiceUrl = environment.apiUrl + '/v1/clients/';

  /**
   *
   * @param {HttpClient} http
   * @param {SpinnerService} spinnerService
   */
  constructor(
    private http: HttpClient,
    private spinnerService: SpinnerService,
  ) { }

  /**
   *
   * Método que devuelve los receivers que coinciden con el criterio de busqueda indicado
   * @param {IReceiverCriteria} receiverCriteria indica el campo por el que filtrar
   * @return {Observable<IReceiverList>}
   */
  getReceivers(receiverCriteria: IReceiverCriteria): Observable<IReceiverList> {
    this.spinnerService.setSpinner(true);
    const url = this.receiversUrl;
    const options = { params: new HttpParams()
      .set(receiverCriteria.filter, receiverCriteria.value)
      .set('page', receiverCriteria.page.toString())
    };

    return this.http.get<IReceiverList>(url, options)
      .map(res => {
        this.spinnerService.setSpinner(false);
        return res as IReceiverList;
      })
      .catch(error => {
        this.spinnerService.setSpinner(false);
        return Observable.throw(error);
      });
  }

  /**
   *
   * Método que devuelve los receivers del usuario que coinciden con el filtro de busqueda indicado
   * @param {string} identifier
   * @param {IReceiverFilter} filter indica el campo por el que filtrar
   * @return {Observable<IReceiverList>}
   */
  getClientReceivers(identifier: string, filter: IReceiverFilter): Observable<IReceiverList> {
    this.spinnerService.setSpinner(true);
    filter.platformName = filter.platformName.trim();
    filter.direName = filter.direName.trim();
    const url = this.clientsServiceUrl + `${identifier}/receivers`;
    return this.http.get<IReceiverList>(url, { params: filter as any })
      .map(res => {
        this.spinnerService.setSpinner(false);
        return res as IReceiverList;
      })
      .catch(error => {
        this.spinnerService.setSpinner(false);
        return Observable.throw(error);
      });
  }

  /**
   *
   * @param {string} identifier
   * @param {IReceiverFilter} filter
   * @return {Observable<IReceiverList>}
   */
  getInvoicingServiceReceivers(identifier: string, filter: IReceiverFilter): Observable<IReceiverList> {
    this.spinnerService.setSpinner(true);
    filter.direName = filter.direName.trim();
    const url = this.invoicingServiceUrl + `${identifier}/receivers`;
    return this.http.get<IReceiverList>(url, { params: filter as any })
      .map(res => {
        this.spinnerService.setSpinner(false);
        return res as IReceiverList;
      })
      .catch(error => {
        this.spinnerService.setSpinner(false);
        return Observable.throw(error);
      });
  }

  /**
   *
   * @param {IReceiver[]} receiver
   * @param {IPerson} person
   * @return {Observable<any | any>}
   */
  updateClientReceiver(receiver: IReceiver, person: IPerson) {
    this.spinnerService.setAutoSave(true);
    return this.http.patch(this.clientsServiceUrl + `${person.identifier}/receivers/${receiver.id}`, receiver)
      .map(res => {
        this.spinnerService.setAutoSave(false);
        return res;
      })
      .catch(error => {
        this.spinnerService.setAutoSave(false);
        if(error.status === 409){
          return Observable.throw('cli.receiver.errors.receiverStateConflict');
        }else {
          return Observable.throw(error);
        }
      });
  }

  /**
   *
   * @param {IPlatform} oldPlatform
   * @param {IReceiver} receiver
   * @param {string} identifier
   * @return {Observable<IReceiver>}
   */
  updateInvoicingServiceReceiver(oldPlatform: IPlatform, receiver: IReceiver, identifier: string): Observable<IReceiver> {
    this.spinnerService.setAutoSave(true);
    return this.http.patch(this.invoicingServiceUrl + `${identifier}/platforms/${oldPlatform.id}/receivers/${receiver.id}`, receiver)
      .map(res => {
        this.spinnerService.setAutoSave(false);
        return res;
      })
      .catch(error => {
        this.spinnerService.setAutoSave(false);
        if(error.status === 409){
          return Observable.throw('inv.receiver.errors.receiverStateConflict');
        }else {
          return Observable.throw(error);
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/receiver.service.ts